import type { ButtonProps } from '@nextui-org/react';
import React from 'react';

import { IconPaginationDown } from '@/assets';

import Buttons from './button/Button';

const ButtonViewMore: React.FC<
  {
    isShowBtn: boolean;
    isViewMore: boolean;
    toggle: Function;
    className?: string;
  } & ButtonProps
> = ({ isShowBtn, isViewMore, toggle, ...props }) => {
  if (!isShowBtn) return null;

  return (
    <Buttons onClick={() => toggle()} typeBtn="ghost" {...props}>
      View {isViewMore ? 'less' : 'more'}
      <IconPaginationDown className={isViewMore ? 'rotate-180' : 'rotate-0'} />
    </Buttons>
  );
};

export default ButtonViewMore;
